import type { RootState } from 'store/root/reducers';

const getCurrentState = (state: RootState) => state['gallery'];

const gallerySelectors = {
  pendingGallery: (state: RootState) => getCurrentState(state).pendingGallery,
  approvedGallery: (state: RootState) => getCurrentState(state).approvedGallery,
  staff: {
    pendingGallery: (state: RootState) => getCurrentState(state).staffPendingGallery,
    approvedGallery: (state: RootState) => getCurrentState(state).staffApprovedGallery,
  }
};

export default gallerySelectors;
